<script setup>
import ChildLine from "./ChildLine.vue";
import {computed} from "vue";

const siteUrl = document.querySelector('meta[name="site-url"]').content;
const props = defineProps({
  comment: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  empathy: {
    type: Array,
    required: true,
  },
  violations: {
    type: Array,
    required: true,
  },
  isSelf: {
    type: Boolean,
    required: true,
  },
  userId: {
    type: Number,
    required: true
  }
});
const emits = defineEmits(['set-empathy', 'set-violation', 'set-delete']);

// 作成日時
const createdAt = computed(() => {
  return new Date(Number(props.comment.created_at) * 1000);
});

// このコメントにに対して共感しているか
const isEmpathy = computed(() => {
  return props.empathy.includes(props.comment.id);
});

// このコメントが違反報告されているか
const isViolation = computed(() => {
  return props.violations.includes(props.comment.id);
});

// 改行で区切って配列にする
const contentLine = computed(() => props.comment.content.split('\n'));
</script>

<template>
  <div class="lyMb16 pBackColorWhite pBorderRadius4px">
    <div class="pageBoardWrapper">
      <div class="lyPd8 pBorderBottom1pxSolidGray4">
        <div class="lyHorizontalBw">
          <div class="lyVerticalCntBreak lyMr16">
            <p class="lyMr4">
              <a
                :href="siteUrl+'place/user/'+comment.user_link_id	"
                class="pFontBold"
              >{{comment.user_nickname}}</a>
            </p>
            <div class="lyHorizontal pFont12 pFontMedium">
              <span class="lyMr4">さん</span>
              <span class="lyMr4">東京都</span>
              <span>30代</span>
            </div>
          </div>
        </div>
        <ul class="lyHorizontalBreak lyMt4">
          <ChildLine
            v-for="child in comment.public_children"
            :key="child.id"
            :child="child"
          />
        </ul>
      </div>
      <div class="lyPd8 lyVerticalCntBreak">
        <p class="lyMr8 pFont12 pFontGray30"><time
          :datetime="String(createdAt.getFullYear()).padStart(2, '0')+'-'+String(createdAt.getMonth() + 1).padStart(2, '0')+'-' +String(createdAt.getDate()).padStart(2, '0')+'T'+String(createdAt.getHours()).padStart(2, '0')+':'+String(createdAt.getMinutes()).padStart(2, '0')"
          class="pFontMedium"
        >{{String(createdAt.getFullYear()).padStart(2, '0')+'.'+String(createdAt.getMonth() + 1).padStart(2, '0')+'.' +String(createdAt.getDate()).padStart(2, '0')+' '+String(createdAt.getHours()).padStart(2, '0')+':'+String(createdAt.getMinutes()).padStart(2, '0')}}</time></p>
      </div>
      <div class="lyPd8">
        <p
          v-for="line in contentLine"
          class="pFont14">{{line}}</p>
      </div>
      <div class="lyPl8">
        <div class="lyVerticalBwCnt">
          <div class="lyHorizontal">
            <label
              :style="isSelf ? 'pointer-events:none;' : ''"
              class="pChip dGood dGreen"
            >
              <input
                :checked="isEmpathy"
                type="checkbox"
                @change="emits('set-empathy', {index: index, checked: $event.target.checked})"
              >
              <span class="pFont14 pFontMedium">{{comment.empathy.length}}</span>
            </label>
          </div>
          <button
            v-if="isSelf"
            type="button"
            class="lyPd8"
            @click="emits('set-delete', index)"
          ><img
            :src="siteUrl+'images/iconDelete.svg'"
            width="16"
            height="16"
            alt="コメントの削除はこちら"
          ></button>
          <button
            v-else-if="userId !== 0"
            type="button"
            class="lyPd8"
            @click="emits('set-violation', {index: index, checked: ! isViolation})"
          ><img
            :src="siteUrl+(isViolation ? 'images/iconViolationCrnt.svg' : 'images/iconViolation.svg')"
            style="width: 16px;"
            width="16"
            height="16"
            loading="lazy"
            alt="違反報告はこちら"
          ></button>
          <span v-else></span>
        </div>
      </div>
    </div>
  </div>
</template>
